import { render, staticRenderFns } from "./book-learn.vue?vue&type=template&id=36f670a8&scoped=true"
import script from "./book-learn.vue?vue&type=script&lang=js"
export * from "./book-learn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f670a8",
  null
  
)

export default component.exports